export const iconFontAwesomeSocialUser = (
	<i className="fa-solid fa-user"></i>
);
